export class Action {
    id_action: string;
    id_actu: string;
    id_inter_rucher: string;
    id_histo_ruche: string;
    type_action: string;
    commentaires: string;

  constructor() {
  }
}


// WEBPACK FOOTER //
// ./src/app/models/action.ts